import { useMemo } from 'react';

// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

// project imports
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';
import IconButton from 'components/@extended/IconButton';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';

// assets
import MenuOutlined from '@ant-design/icons/MenuOutlined';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

export default function Header() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  // header content
  const headerContent = useMemo(() => <HeaderContent />, []);

  // common header
  const mainHeader = (
    <Toolbar>
      {downLG && !drawerOpen && (
        <IconButton
          aria-label="open drawer"
          onClick={() => handlerDrawerOpen(true)}
          edge="start"
          sx={{
            width: 32,
            height: 32,
            p: 0,
            borderRadius: '50%',
            color: '#ffffff',
            bgcolor: '#1e3a5f',
            boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
            '&:hover': {
              bgcolor: '#163152',
              color: '#ffffff'
            },
            '& .anticon': { color: '#ffffff' },
            '& .anticon svg': { fill: '#ffffff' }
          }}
        >
          <MenuOutlined style={{ fontSize: 15, color: '#ffffff' }} />
        </IconButton>
      )}
      {headerContent}
    </Toolbar>
  );

  // app-bar params
  const appBar = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      borderBottom: '1px solid',
      borderBottomColor: 'divider',
      zIndex: 1200,
      ml: { lg: drawerOpen ? `${DRAWER_WIDTH}px` : `${MINI_DRAWER_WIDTH}px` },
      width: { xs: '100%', lg: drawerOpen ? `calc(100% - ${DRAWER_WIDTH}px)` : `calc(100% - ${MINI_DRAWER_WIDTH}px)` }
    }
  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={drawerOpen} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
}
